import Phaser from "phaser";
import VfxSprite from "./VfxSprite";

export default class CoinFountain extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, gameData) {
        super(scene, x, y);

        // Store reference to the scene
        this.scene = scene;

        // Store the gameData for later use
        this.gameData = gameData;

        // Register this game object with the scene
        this.scene.add.existing(this);
        
        this.startAnimation(x, y, scale);
    }
    
    startAnimation(x, y, scale) {

        // show closed chest for a second
        this.chestClosed = this.scene.add.image(x, y * 0.9, 'all_images', 'win_crate_closed').setScale(1.1 * scale).setDepth(101);
        this.chestClosed.setVisible(true);

        // Add vfx for winner
        let vfx1 = new VfxSprite(this.scene, x, y, 'star_burst', 0, {
            direction: 0,
            scale: 4,
            frames: 64,                                
        });
        vfx1.setDepth(101);

        this.scene.time.delayedCall(1000, () => {
            this.chestClosed.setVisible(false);

            // Determine the images based on the wagerType
            const wagerType = this.gameData.matchInfo.wagerType;
            const chestImage = wagerType === 'bonez' ? 'win_crate_open_bonez' : 'win_crate_open_chipz';
            const coinImage = wagerType === 'bonez' ? 'zoombies_bonez' : 'zoombies_chipz';
            
            // show open chest
            this.chestOpen = this.scene.add.image(x, y * 0.9, 'all_images', chestImage).setScale(1.1 * scale).setDepth(101);
            const numCoins = (this.gameData.matchInfo.potAmount - this.gameData.matchInfo.tableFee) * 4; // Number of coins to burst out

            const spawnCoin = () => {
                // Randomize the coins coming out
                const coin = this.scene.physics.add.sprite(Phaser.Math.Between(x - 200, x + 200), y, coinImage);
                coin.setVelocity(Phaser.Math.Between(-700, 700), Phaser.Math.Between(-1800, -800)); 
                coin.setGravityY(1400);
                coin.setDepth(101); 
            
                // Set the initial scale for bonez
                if (wagerType === 'bonez') {
                    coin.scaleX = 0.5;
                    coin.scaleY = 0.5;
                    //change the bonez angle
                    coin.angle = Phaser.Math.Between(-180, 180);
                }
            
                // Simulate 3D flip using scaling
                this.scene.tweens.add({
                    targets: coin,
                    scaleX: { from: coin.scaleX, to: 0.1 * coin.scaleX },
                    scaleY: { from: coin.scaleY, to: 1.1 * coin.scaleY },
                    yoyo: true,
                    repeat: -1,
                    duration: Phaser.Math.Between(200, 500),
                });
            };

            // Setup timed event loop to spawn coins
            this.scene.time.addEvent({
                delay: 35, 
                callback: spawnCoin,
                callbackScope: this,
                repeat: numCoins - 1 
            });
        }, this);
    }
}